module.exports = __webpack_public_path__ + "img/empty-message-box_red.78b23efe.svg";